import cxs from 'cxs';
import { COLOURS } from '../../../../../common/styles/vars';

export const CARD_OVERLAY = cxs({
  position: 'absolute',
  left: 0,
  top: 0,
  height: '100%',
  width: '100%',
  background: 'rgba(0, 0, 0, 0.75)',

  ' > div.favourite-icon': {
    position: 'absolute',
    left: '15px',
    top: '15px'
  }
});

export const CARD_OVERLAY_MORE_ICON = cxs({
  height: '30px',
  width: '30px',
  position: 'absolute',
  right: '15px',
  top: '15px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});

export const CARD_OVERLAY_BUTTON = cxs({
  position: 'absolute',
  top: '43%',
  left: '50%',
  transform: 'translate(-50%, 0%)',
  backgroundColor: 'rgba(255, 255, 255, 0.35)',
  border: `1px solid ${COLOURS.grey.athens.parthenon}`,
  borderRadius: '6px',
  height: '50px',
  cursor: 'pointer',
  paddingLeft: '25px',
  paddingRight: '25px',

  ':hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.2)'
  }
});